import React from 'react';
import styled from 'styled-components';

export const crewTypesI18n = I18n.t('classy_enum.station_crew_type');

const ColoredLabel = styled.span`
  background: ${props => props.backgroundColor};
  color: ${props => props.fontColor};
  padding: 2px 4px;
  border-radius: 5px;
`;

// Renders the name of the team in the right color, and puts the station name in
// front of it. Example: "FSR Headquarters - Red", with "Red" as a red colored
// label

const backgroundColorList = {
  retained: 'green',
  wholetime: 'blue',
  mixed: 'orange',
  unknown: 'white'
};

const fontColorList = {
  retained: 'white',
  wholetime: 'white',
  mixed: 'white',
  unknown: 'grey'
};

const CrewTypeLabel = ({ crewType, displayText, showUnknown }) => {
  if (crewType === 'unknown' && !showUnknown) return null;

  return (
    <ColoredLabel fontColor={fontColorList[crewType]} backgroundColor={backgroundColorList[crewType]}>
      {displayText}
    </ColoredLabel>
  );
};

export default CrewTypeLabel;
